import './Banner.sass';

import React, { FC } from 'react';
import { BannerProps } from '$uikit/Banner/Banner.interface';
import { classNames } from '$utils';
import { IcChevron16 } from '$assets';

export const Banner: FC<BannerProps> = (props) => {
  const { title, caption, mode = 'primary', onClick } = props;

  return (
    <div
      onClick={onClick}
      className={classNames({
        Banner: true,
        [mode]: true,
      })}
    >
      <div className="Banner__cont">
        <div className="Banner__title">{title}</div>
        <div className="Banner__caption">{caption}</div>
      </div>
      <div className="Banner__arrow">
        <IcChevron16 />
      </div>
    </div>
  );
};
